import React from 'react';
import { AdminUsersTable } from '@/components/admin/table/AdminUsersTable';
import { useAdminUsers } from '@/hooks/useAdminUsers';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const AdminUsersPage: React.FC = () => {
  const { users, isLoading } = useAdminUsers();

  if (isLoading) {
    return <div>Loading users...</div>;
  }

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Manage Users</CardTitle>
      </CardHeader>
      <CardContent>
        {users && users.length > 0 ? (
          <AdminUsersTable users={users} />
        ) : (
          <div>No users found.</div>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminUsersPage;
